<template>
  <v-row>
    <v-col cols="12" sm="4" md="6" class="p-0">
      <img :src="getLogo()" class="logo" alt="logo" />
    </v-col>
    <v-col cols="12" sm="8" md="6" class="p-0">
      <div class="d-flex justify-content-between align-items-center">
        <v-btn
          color="#25bdad"
          class="refresh-btn"
          x-large
          @click="$emit('refreshClicked')"
        >
          <v-icon color="white">fas fa-sync fa-fw</v-icon>
        </v-btn>
        <v-menu
          bottom
          left
          color="#25bdad"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#25bdad"
              x-large
              class="language-btn"
              v-bind="attrs"
              v-on="on"
            >
              {{ $t("LANGUAGE") }}
            </v-btn>
          </template>

          <v-list>
            <v-list-item link>
              <v-list-item-title @click="onLanguageChanged('bg')">{{ $t("BULGARIAN") }}</v-list-item-title>
            </v-list-item>
            <v-list-item link>
              <v-list-item-title @click="onLanguageChanged('en')">{{ $t("ENGLISH") }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <h4 class="d-flex align-items-center mb-0 date">{{ today }}</h4>
        <h2 class="d-flex align-items-center mb-0 time">{{ time }}</h2>
        <v-btn icon color="red" x-large @click="logout">
          <v-icon>flaticon-logout</v-icon>
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import { LOGOUT } from "@/store/auth.module";

export default {
  data() {
    return {
      time: moment().format("HH:mm:ss"),
      today: moment().format("DD/MM/YYYY")
    };
  },

  mounted() {
    setInterval(this.renderClock, 1000);
  },

  methods: {
    renderClock() {
      this.time = moment().format("HH:mm:ss");
    },

    getLogo() {
      return process.env.BASE_URL + "assets/media/logos/logo-small.png";
    },

    onLanguageChanged(language) {
      localStorage.setItem("language", language);
      window.location.reload();
    },

    logout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    }
  }
};
</script>

<style scoped>
.logo {
  width: 20vw;
}

.refresh-btn {
  width: 52px !important;
  max-width: 52px !important;
  min-width: 52px !important;
}

.language-btn {
  color: white !important;
  font-size: 1.2rem !important;
  margin: 0 10px;
}

.date {
  font-size: 3vw;
}

.time {
  font-size: 4vw;
}
</style>
